import React from 'react';

import Icon from '~/core/scripts/components/Icon';

const ClearIndicator = ({ innerProps }) => (
  <button
    className="btn btn-clear"
    onMouseDown={evt => {
      evt.preventDefault();
      evt.stopPropagation();

      innerProps.onMouseDown(evt);
    }}
    onTouchEnd={evt => {
      evt.preventDefault();
      evt.stopPropagation();

      innerProps.onTouchEnd(evt);
    }}
  >
    <Icon type="close" />
  </button>
);

ClearIndicator.displayName = 'ClearIndicator';

export default ClearIndicator;
